import { render } from "./Advisor.vue?vue&type=template&id=852ec320&scoped=true"
import script from "./Advisor.vue?vue&type=script&lang=js"
export * from "./Advisor.vue?vue&type=script&lang=js"

import "./Advisor.vue?vue&type=style&index=0&id=852ec320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852ec320"]])

export default __exports__